export default __webpack_public_path__ + "static/media/Harvest.7fdee87f.jpg";